import React, {Component} from 'react';

import {DownloadCloudIcon, SandClockIcon, SuccessGreenIcon} from '../../components/Common/Icons/Icons'
import ButtonInput from '../../components/Common/ButtonInput'
import {connect} from 'react-redux';
import './TransactionPage.scss';
import {Api} from "../../api";
import {checkAuth, getAuthToken} from "../../utils";

class TransactionStatus extends Component {

    
    render() {

        //TODO recive from parent object
        const userId = this.props.userId;
        const transactionData = this.props.transactionData;

        const signedBySender = transactionData !== null && transactionData.senderDigitalSignature && transactionData.senderDigitalSignature.confirmTime;
        const signedByRecipient = transactionData !== null && transactionData.recipientDigitalSignature && transactionData.recipientDigitalSignature.confirmTime;
        const signedByCryptoId = transactionData !== null && transactionData.cryptoIdSignature && transactionData.cryptoIdSignature.confirmTime;
        return (
            <div>
                <div className="content-h2 m-t-20 m-b-15">
                    Signatures
                </div>
                <div className="fields-row m-b-31">
                    <div className={`signature-block
                            ${(signedBySender) && 'sender-signed'}`}>
                        <div className="signature-title sender">SENDER</div>
                        {(signedBySender) ?
                            <div className="signed-block">
                                <div className="fields-row time-signed">
                                    {transactionData.senderDigitalSignature.confirmTime}
                                </div>
                                <div className="fields-row entity-signed">
                                    {transactionData.senderDigitalSignature.owner}
                                </div>
                                <div className="fields-row name-signed">
                                    {transactionData.senderDigitalSignature.entity}
                                </div>
                            </div> :
                            (((transactionData !== null && transactionData.senderEntity && userId === transactionData.senderEntity.userId) || transactionData.userStatus === 'Sender') ?
                                <div className="fields-row">
                                    <div className="sign-digital-signature">Digital signature</div>
                                    <ButtonInput
                                        width='116'
                                        size='middle'
                                        className={`dark-button dark-button blue-button m-r-0`}
                                        title='Sign'
                                        handleClick={() => this.props.onDigitalSign()}/>
                                </div> :
                                <div className="fields-row status-waiting">
                                    <div className="sign-digital-signature">Digital signature</div>
                                    <div className="sign-status">Waiting for sign</div>
                                </div>)

                        }
                    </div>

                    <div className="sand-clock-block">
                        <div
                            className={`sender-arrow ${(signedBySender)
                            && 'done'}`}/>
                        {(!signedByCryptoId) ?
                            <div
                                className={`clock-block ${(signedBySender)
                                && 'sender-done'} ${(signedByRecipient) && 'recipient-done'}`}>
                                <SandClockIcon/>
                            </div>
                            :
                            <div className="success-icon-block">
                                <SuccessGreenIcon/>
                            </div>}
                        <div className={`recipient-arrow ${(signedByRecipient) && 'done'}`}/>
                        {/*<div className={`cryptoid-arrow ${(signedByCryptoId) && 'all-signs'}`}/>*/}
                    </div>

                    <div className={`signature-block recipient
                            ${(signedByRecipient) && 'recipient-signed'}`}>
                        <div className="signature-title">RECIPIENT</div>
                        {(signedByRecipient) ?
                            <div className="signed-block">
                                <div className="fields-row time-signed">
                                    {transactionData.recipientDigitalSignature.confirmTime}
                                </div>
                                <div className="fields-row entity-signed">
                                    {transactionData.recipientDigitalSignature.owner}
                                </div>
                                {transactionData.recipientDigitalSignature.role &&
                                    <div className="fields-row name-signed">
                                        {transactionData.recipientDigitalSignature.role}
                                    </div>
                                }
                                <div className="fields-row name-signed">
                                    {transactionData.recipientDigitalSignature.entity}
                                </div>
                            </div> :
                            (((transactionData !== null && transactionData.recipientEntity && userId === transactionData.recipientEntity.userId) || transactionData.userStatus === 'Recipient') ?
                                <div className="fields-row">
                                    <div className="sign-digital-signature">Digital signature</div>
                                    <ButtonInput
                                        width='116'
                                        size='middle'
                                        className={`dark-button dark-button blue-button m-r-0`}
                                        title='Sign'
                                        handleClick={() => this.props.onDigitalSign()}/>
                                </div> :
                                <div className="fields-row status-waiting">
                                    <div className="sign-digital-signature">Digital signature</div>
                                    <div className="sign-status">Waiting for sign</div>
                                </div>)}
                    </div>
                </div>
                {/*<div className="fields-row">*/}
                    {/*{(signedByCryptoId) ?*/}
                        {/*<div className="cryptoid-signature-block cryptoid-signed">*/}
                            {/*<div className="signature-title sender">CRYPTOID</div>*/}
                            {/*<div className="signed-block">*/}
                                {/*<div className="fields-row time-signed">*/}
                                    {/*{transactionData.cryptoIdSignature.confirmTime}*/}
                                {/*</div>*/}
                                {/*<div className="fields-row entity-signed">*/}
                                    {/*{transactionData.cryptoIdSignature.owner}*/}
                                {/*</div>*/}
                                {/*<div className="fields-row name-signed">*/}
                                    {/*{transactionData.cryptoIdSignature.entity}*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div> :*/}
                        {/*<div className="cryptoid-signature-block">*/}
                            {/*<div className="waiting-block">System signs aitomatically when all signatures are*/}
                                {/*applied*/}
                            {/*</div>*/}
                        {/*</div>}*/}
                {/*</div>*/}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(TransactionStatus);



// WEBPACK FOOTER //
// ./src/views/TransactionStatus/TransactionStatus.js